import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense, useMemo } from 'react';
import { MobXProviderContext } from 'mobx-react';
import Root from '@view/pages/Root';
// AppProvider wraps the shared BaseProviders (react-query, style cache, theme,
// portals, i18n) with the store-coupled values (property colors, immersive).
const AppProvider = React.lazy(() => import(/* webpackChunkName: "app-provider" */ '@view/providers/app'));
const AppInner = ({ storeLoader }) => {
    const store = useMemo(() => storeLoader(), [storeLoader]);
    return (_jsx(MobXProviderContext.Provider, { value: { store }, children: _jsx(Suspense, { children: _jsx(AppProvider, { children: _jsx(Root, {}) }) }) }));
};
export default AppInner;
